
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"opacity":".3","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M18 5h3","stroke":"#DB2121"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.103 8.228a1 1 0 011.794 0l.616 1.249a1 1 0 00.753.547l1.377.2a1 1 0 01.554 1.705l-.997.973a1 1 0 00-.287.885l.235 1.371a1 1 0 01-1.45 1.054l-1.233-.647a1 1 0 00-.93 0l-1.232.647a1 1 0 01-1.451-1.054l.235-1.371a1 1 0 00-.287-.885l-.997-.973a1 1 0 01.554-1.705l1.377-.2a1 1 0 00.754-.547l.615-1.249z","fill":"#F9B621","stroke":"#494949"}}),_c('path',{attrs:{"d":"M14 3.238A8.81 8.81 0 0012 3a9 9 0 109 9 8.81 8.81 0 00-.238-2","stroke":"#494949"}})])])
          )
        }
      }
    